<template>
  <div class="ak-action-grid">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-action-grid theme="dark">...</ak-action-grid>
   */

  name: 'AkActionGrid',
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-action-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  &--dark {
    color: #fff;
  }
}
</style>
